import { FlexBox, Text } from '@blockworks/ui';

import { useFormatValue } from '../../../format/utils/use-format-value';

import { CounterProps } from './counter.model';
import { useCounterOptions } from './utils';

const Counter = ({ data, options, meta, activeControls, params }: CounterProps) => {
    const { rowIndex, column, hasNegativeColor, hasPositiveColor, format, label, labelSize } = useCounterOptions({
        activeControls,
        options,
        params,
    });

    const hasColumn = !!column;
    const { formattedValue, color } = useFormatValue({
        d3Format: format,
        value: hasColumn && !!data?.[rowIndex]?.[column] ? data[rowIndex][column] : '',
        type: hasColumn ? meta?.columnTypes?.[column] : undefined,
        hasPositiveColor,
        hasNegativeColor,
    });

    if (!hasColumn || !data?.[rowIndex]?.[column]) {
        return null;
    }

    return (
        <FlexBox col h="full" w="full" alignItems="center" justifyContent="center" p={4} pos="relative">
            <FlexBox pos="relative" center w="full">
                <Text className={`text-[clamp(2rem,3vw,3rem)] leading-none`} lineHeight={1} center color={color}>
                    {formattedValue}
                </Text>
                {label && (
                    <Text size={labelSize || 'xl'} center className={`absolute top-full`}>
                        {label}
                    </Text>
                )}
            </FlexBox>
        </FlexBox>
    );
};

export { Counter };
